import {Button, DataTable, Link, Text} from '@/components-v2'
import {useProductListTableV2} from '@/hooks/useProductListTableV2'
import {ComboProductListColConfig} from '@/services/MockData/Products/ComboProductListColConfig'
import {DEFAULT_TABLE_PAGE_SIZE} from '@/utils/constants/commonConstants'
import {ROUTES} from '@/utils/constants/routesConstants'
import {useMemo} from 'react'
import {useNavigate} from 'react-router-dom'

const toSafeRouteParam = value => {
  const raw = String(value ?? '').trim()

  if (!raw || raw.includes('..') || !/^[A-Za-z0-9._-]+$/.test(raw)) return ''
  return encodeURIComponent(raw)
}

export const ComboListTabContent = () => {
  const navigate = useNavigate()
  const columns = useMemo(
    () =>
      ComboProductListColConfig.map(column => ({
        columnKey: column.name_of_db_column,
        header: column.label_of_column,
        columnFilterPlaceholder: column.label_of_column,
        ...(column.filterVariant ? {filterVariant: column.filterVariant} : {}),
        ...(column.name_of_db_column === 'productId' && {
          cellData: ctx => {
            const productId = ctx.row.original?.productId
            const safeId = toSafeRouteParam(productId)
            return (
              <Link
                useAnchor={false}
                label={productId ?? '-'}
                onClick={safeId ? () => navigate(ROUTES.PRODUCT_COMBO_DETAIL.replace(':id', safeId)) : undefined}
              />
            )
          },
        }),
      })),
    [navigate]
  )

  const {
    tableData,
    isFetching,
    pageIndex,
    pageSize,
    totalRowsCount,
    manualPagination,
    manualSorting,
    manualFiltering,
    onPageIndexChange,
    onRowsPerPageChange,
    sortingHandler,
    onColumnFiltersChange,
    resetFilterButtonOptions,
    onTableReady,
  } = useProductListTableV2(DEFAULT_TABLE_PAGE_SIZE, null, [], columns, true)

  const customHeader = (
    <div className="datatable-custom-header">
      <Button
        variant="tertiary"
        size="medium"
        text={resetFilterButtonOptions?.text ?? 'Reset All'}
        onClick={resetFilterButtonOptions?.onFiltersReset}
      />
      <Button
        variant="primary"
        size="medium"
        text="Create Combo"
        onClick={() => navigate(ROUTES.CREATE_PRODUCT_COMBINATION)}
      />
    </div>
  )

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col gap-4 rounded-lg bg-[var(--color-background-layer-01)] p-6">
        <Text headingLevel={5}>Combo List</Text>
        <DataTable
          key={`combo-list-${columns.map(column => column.columnKey).join(',')}`}
          columns={columns}
          data={tableData}
          isLoading={isFetching}
          pageIndex={pageIndex}
          pageSize={pageSize ?? DEFAULT_TABLE_PAGE_SIZE}
          totalRowsCount={totalRowsCount}
          onPageIndexChange={onPageIndexChange}
          onRowsPerPageChange={onRowsPerPageChange}
          manualPagination={manualPagination}
          manualSorting={manualSorting}
          manualFiltering={manualFiltering}
          sortingHandler={sortingHandler}
          onColumnFiltersChange={onColumnFiltersChange}
          resetFilterButtonOptions={resetFilterButtonOptions}
          onTableReady={onTableReady}
          selection="none"
          showTableHeader={false}
          customHeader={customHeader}
        />
      </div>
    </div>
  )
}